
export const setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime()+(exdays * 24 * 60 * 60 * 1000));
    document.cookie = `${cname}=${cvalue}; expires=${d.toUTCString()}` ;
}

export const getCookie = (cname) => {
    let cookies = document.cookie.split(';');
    let response = null;
    
    cookies.forEach(cookie => {
        const result = cookie.trim().split("=")

        if(result[0] === cname){
            return response = result[1];
        }
    });

    return response;
  }